import {
  Checkbox,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import moment from 'moment';
import React from 'react';
import { DocumentTypesEnum_class } from '../../../../../../common/enums/documentTypes';
import { downloadResourceAction } from '../resources.actions';
import { ResourceDto } from '../resources.dtos';

interface IProps {
  resources: ResourceDto[];
  editResource: (value: ResourceDto, type: number) => void;
}

const ResourcesTable: React.FC<IProps> = ({ resources, editResource }) => {
  const columnNames = [
    'Name',
    'Created On',
    'Uploaded By',
    'Document Type',
    'File URL',
    'Active',
    'Download',
  ];

  const onDownload = async (
    uploadName: string,
    mimeType: string,
    fileName: string
  ) => {
    await downloadResourceAction(uploadName, mimeType, fileName);
  };

  return (
    <TableContainer component={Paper}>
      <Table aria-label='facility resources table'>
        <TableHead>
          <TableRow>
            {columnNames.map((c, i) => (
              <TableCell key={i} align='center'>
                {c}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {resources.length > 0 ? (
            resources.map((r, i) => (
              <TableRow key={i}>
                <TableCell component='th' scope='row'>
                  <Link onClick={() => editResource(r, r.typeId)}>
                    {r.name}
                  </Link>
                </TableCell>
                <TableCell align='center'>
                  {moment(r.createdOn).format('MM/DD/YYYY')}
                </TableCell>
                <TableCell align='center'>{r.uploadedBy}</TableCell>
                <TableCell align='center'>{r.documentType}</TableCell>
                <TableCell align='center'>
                  {r.documentTypeId === DocumentTypesEnum_class.enum.URL ? (
                    <Link href={r.fileUrl}>{r.fileUrl}</Link>
                  ) : (
                    <Link
                      onClick={() => {
                        onDownload(
                          r.file!.uploadFileName,
                          r.file!.mimeType,
                          r.name
                        );
                      }}
                    >
                      {r.fileUrl}
                    </Link>
                  )}
                </TableCell>
                <TableCell align='center'>
                  <Checkbox
                    name='isActive'
                    color='primary'
                    checked={r.isActive}
                    inputProps={{ readOnly: true }}
                  />
                </TableCell>
                <TableCell align='center'>
                  {r.documentTypeId === DocumentTypesEnum_class.enum.URL ? (
                    <Link href={r.fileUrl}>View</Link>
                  ) : (
                    <Link
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        onDownload(
                          r.file!.uploadFileName,
                          r.file!.mimeType,
                          r.name
                        );
                      }}
                    >
                      Download
                    </Link>
                  )}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell align='center' colSpan={columnNames.length}>
                No data
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ResourcesTable;
